/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SessionIpEnrichment } from './SessionIpEnrichment';
import {
    SessionIpEnrichmentFromJSON,
    SessionIpEnrichmentFromJSONTyped,
    SessionIpEnrichmentToJSON,
    SessionIpEnrichmentToJSONTyped,
} from './SessionIpEnrichment';
import type { User } from './User';
import {
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
    UserToJSONTyped,
} from './User';

/**
 * 
 * @export
 * @interface GetUserSessionsResponseItem
 */
export interface GetUserSessionsResponseItem {
    /**
     * 
     * @type {Array<User>}
     * @memberof GetUserSessionsResponseItem
     */
    otherUsersUsingIp: Array<User>;
    /**
     * 
     * @type {string}
     * @memberof GetUserSessionsResponseItem
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof GetUserSessionsResponseItem
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof GetUserSessionsResponseItem
     */
    updatedAt: number;
    /**
     * 
     * @type {string}
     * @memberof GetUserSessionsResponseItem
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof GetUserSessionsResponseItem
     */
    tokenId: string;
    /**
     * 
     * @type {string}
     * @memberof GetUserSessionsResponseItem
     */
    ipAddress: string;
    /**
     * 
     * @type {string}
     * @memberof GetUserSessionsResponseItem
     */
    userAgent?: string;
    /**
     * 
     * @type {number}
     * @memberof GetUserSessionsResponseItem
     */
    apiCounter: number;
    /**
     * 
     * @type {SessionIpEnrichment}
     * @memberof GetUserSessionsResponseItem
     */
    ipEnrichment?: SessionIpEnrichment;
}

/**
 * Check if a given object implements the GetUserSessionsResponseItem interface.
 */
export function instanceOfGetUserSessionsResponseItem(value: object): value is GetUserSessionsResponseItem {
    if (!('otherUsersUsingIp' in value) || value['otherUsersUsingIp'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('tokenId' in value) || value['tokenId'] === undefined) return false;
    if (!('ipAddress' in value) || value['ipAddress'] === undefined) return false;
    if (!('apiCounter' in value) || value['apiCounter'] === undefined) return false;
    return true;
}

export function GetUserSessionsResponseItemFromJSON(json: any): GetUserSessionsResponseItem {
    return GetUserSessionsResponseItemFromJSONTyped(json, false);
}

export function GetUserSessionsResponseItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUserSessionsResponseItem {
    if (json == null) {
        return json;
    }
    return {
        
        'otherUsersUsingIp': ((json['otherUsersUsingIp'] as Array<any>).map(UserFromJSON)),
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'userId': json['userId'],
        'tokenId': json['tokenId'],
        'ipAddress': json['ipAddress'],
        'userAgent': json['userAgent'] == null ? undefined : json['userAgent'],
        'apiCounter': json['apiCounter'],
        'ipEnrichment': json['ipEnrichment'] == null ? undefined : SessionIpEnrichmentFromJSON(json['ipEnrichment']),
    };
}

export function GetUserSessionsResponseItemToJSON(json: any): GetUserSessionsResponseItem {
    return GetUserSessionsResponseItemToJSONTyped(json, false);
}

export function GetUserSessionsResponseItemToJSONTyped(value?: GetUserSessionsResponseItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'otherUsersUsingIp': ((value['otherUsersUsingIp'] as Array<any>).map(UserToJSON)),
        'id': value['id'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
        'userId': value['userId'],
        'tokenId': value['tokenId'],
        'ipAddress': value['ipAddress'],
        'userAgent': value['userAgent'],
        'apiCounter': value['apiCounter'],
        'ipEnrichment': SessionIpEnrichmentToJSON(value['ipEnrichment']),
    };
}

